import React, { useState } from 'react';
import { Form, Dropdown } from 'semantic-ui-react';
import { SettleDocument } from 'src/graphql/documents';
import { useDispatch } from 'react-redux';
import { importAlertState } from 'src/redux/actions/alert';
import { importUpdateCashflowNeeded } from 'src/redux/actions/flujocaja';
import { updateConcilieantionRatio } from 'src/redux/actions/dashboard';
import { setUpdateDocuments } from 'src/redux/actions/documentostributarios';
import { formatMoneyWithCurrency } from 'src/utils/formatter';
import { importUpdateNominaInProcessNeeded } from 'src/redux/actions/proveedores';
import moment from 'moment';
import CustomModal from '../../configuracion/components/customModal';
import { useBlockedFeatures } from 'src/hooks/useBlockedFeatures';
 
 export const PartialPayoffModal = ({ companyId, option, selected }) => {
     const dispatch = useDispatch();
     const { isAbonarBlocked } = useBlockedFeatures();
     const [open, setOpen] = useState(false)
     const [amount, setAmount] = useState("")
     const [dateToSettle, setDateToSettle] = useState(moment().format('YYYY-MM-DD'));
     const handleOpen = () => {
         if (isAbonarBlocked()) {
             dispatch(importAlertState({
                 content: 'La función "Abonar" está bloqueada para tu cuenta.',
                 state: 'warning',
                 duration: 4,
             }));
             return;
         }
         const [doc] = selected;
         setAmount(String(doc?.meta?.remaining ?? 0));
         setOpen(true);
     };
     const handleClose = () => {
         setOpen(false);
     };
 
     const { executeMutation } = SettleDocument()
     const [document] = selected
 
     const isAmountBigger = document.meta.remaining < parseInt(amount)

    const normalizeAmountInput = (raw) => {
        const currency = document?.currencyType === 'CLP' ? 'CLP' : 'USD';
        let s = String(raw || '').replace(/\s/g, '');
        if (currency === 'CLP') {
            s = s.replace(/[^0-9]/g, '');
        } else {
            s = s.replace(/,/g, '.').replace(/[^0-9.]/g, '');
            const firstDot = s.indexOf('.');
            if (firstDot !== -1) {
                const before = s.slice(0, firstDot + 1);
                const after = s.slice(firstDot + 1).replace(/\./g, '');
                s = before + after;
            }
        }
        return s;
    };
 
     const handleSubmit = async () => {
         try {
             const cleanAmount = parseFloat(amount)
             const input = selected.map((document) => ({ 
                 id: document.id || document._id, 
                 amount: cleanAmount, 
                 date: dateToSettle 
             }))
             const { data, error } = await executeMutation({ companyId, input })
 
             handleClose();
 
             if (error || data?.settleDocument?.nModified === 0) {
                 return dispatch(
                     importAlertState({
                       content: "Error al saldar, intente nuevamente.",
                       state: "error",
                       duration: 3,
                     })
                   )
             }
 
             dispatch(importUpdateNominaInProcessNeeded({ value: true }))
             dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
             dispatch(updateConcilieantionRatio());
             dispatch(setUpdateDocuments({ value: true }))
 
             dispatch(
                 importAlertState({
                   content: selected.length > 1 ? "Documentos saldados con éxito" : "Documento saldado con éxito",
                   state: "success",
                   duration: 3,
                 })
               )
         } catch (error) {
             console.error(error);
         }
     }
 
     return (
         <>
             <Dropdown.Item value={option?.value} onClick={handleOpen}>
                 {option?.text}
             </Dropdown.Item>
             <CustomModal
                 open={open}
                 onClose={handleClose}
                 dimmer="blurring"
                 size="tiny"
                 title="Saldar documento"
                 confirmLabel="Sí, saldar"
                 onConfirm={handleSubmit}
                 confirmDisabled={isAmountBigger}
                 content={
                     <>
                 <p>¿Estás seguro que deseas saldar este item?</p>
                 <br />
                 <Form.Input
                     label="Monto a saldar:"
                     id="partialPayoffInput"
                     type="text"
                     inputMode="decimal"
                     icon={{ name: "dollar", color: "grey" }}
                     iconPosition='left'
                     placeholder="Ingrese el monto a saldar"
                     value={amount}
                     onChange={(e) => setAmount(normalizeAmountInput(e.target.value))}
                     style={{ paddingLeft: "10px", width: "100%" }}
                 />
                 <div className="mt-3" hidden={!isAmountBigger}>
                   <span className="text-danger">{`El nuevo monto debe tener un rango entre ${formatMoneyWithCurrency(0, document?.currencyType === 'CLP' ? 'CLP' : 'USD')} y ${formatMoneyWithCurrency(document.meta.remaining || 0, document?.currencyType === 'CLP' ? 'CLP' : 'USD')}`}</span>
                 </div>
                 <Form.Input
                         label="¿Con qué fecha de pago debiera saldarse?"
                         type="date"
                         placeholder="Ingrese su Correo"
                         name="date"
                         value={dateToSettle}
                         onChange={(_, v) => setDateToSettle(v.value)}
                         className="w-100 mt-4"
                         style={{ paddingLeft: "10px" }}
                         fluid
                 />
                     </>
                 }
             />
         </>
     );
 };
